export const importCsvStatusOptions = () => [
  { text: 'Pending', key: 'pending' },
  { text: 'In Progress', key: 'in_progress' },
  { text: 'Success', key: 'success' },
  { text: 'Partially Processed', key: 'partially_processed' },
  { text: 'Failed', key: 'failed' },
]
